import { React, useState } from 'react';
import { Container } from "react-bootstrap";
import { Button } from "react-bootstrap";
import CreatePair from "../../Modals/CreatePair";
import LiquidityModel from "../../Modals/LiquidityModel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import iconBoxDelete from "../../assets/images/icon-box-delete.svg";
import waterPic1 from "../../assets/images/water-pic-1.svg";
import waterPic2 from "../../assets/images/water-pic-2.svg";
import Select from 'react-select';
import campassIcon1 from '../../assets/images/campass-icon-1.png';
import tIcon1 from '../../assets/images/t-icon-1.png';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import Accordion from 'react-bootstrap/Accordion';
import Header from '../Header/Header';

import "./pools.css";

const options = [
    { value: 'Account1', label: 'Account analytics and accured fees' },
    { value: 'Account2', label: 'Account analytics and accured fees more' },
    { value: 'Account3', label: 'Account analytics and accured fees much' },
];

function Pools() {
    const [option, setOption] = useState({ value: 'Account1', label: 'Account analytics and accured fees' })

    const handleChange = (selectedOption) => {
        setOption(selectedOption);
        console.log(`Option selected:`, selectedOption);
    };
  return (
    <div>
      <Header />
     <section className="pools-area">
      <Container>
        <div className="pools-banner row d-flex justify-content-between">
          <div className="pools-head col-md-6 text-white">
            <h1>Your Liquidity</h1>
            <div className="pools-para d-flex gap-4 justify-content-start mt-5">
              <p className="light-green mt-2">Liquidity provider rewards</p>
              <FontAwesomeIcon icon={faInfo} className="info-icon" />
            </div>
          </div>
          <div className="pools-btns col-md-6 d-flex justify-content-end gap-3">
            <CreatePair />
            <LiquidityModel />
          </div>
        </div>
        <div className="liquidity-data">
                    <div className="pools-para d-flex gap-4 justify-content-start">
                        <p className="text-white mt-2">Liquidity provider rewards</p>
                        <FontAwesomeIcon icon={faInfo} className="info-icon" />
                    </div>
                    <div className="pool-select-data">
                        <Select id="color"
                            value={option}
                            onChange={() => handleChange()}
                            classNamePrefix="mySelect"
                            options={options}
                        />
                    </div>
                    <div className="pool-accordin-data">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    <div className="accordin-head d-flex gap-md-3 gap-1 w-50">
                                        <div className="accordin-img-1">
                                            <img src={campassIcon1} alt="" />
                                        </div>
                                        <div className="accordin-img-1">
                                            <img src={tIcon1} alt="" />
                                        </div>
                                        <div className="accordin-img-head mt-2">
                                            <h3>CAO/AMPL</h3>
                                        </div>
                                    </div>
                                    <div className="accordin-img-head-2 d-flex mt-1 gap-md-3 gap-1 w-50 justify-content-end align-items-center">
                                        <h3 className="green">Manage</h3>
                                        <FontAwesomeIcon icon={faAngleDown} className="angle-down-icon green" />
                                    </div>
                                </Accordion.Header>
                                <div className="hr-1"></div>
                                <Accordion.Body>
                                    <div className="accordin-body text-white">
                                      <div className="total-flex d-flex justify-content-between mt-2 align-items-center">
                                        <h3>Your Total Pool</h3>
                                        <h3>0.0000000043</h3>
                                      </div>
                                      <div className="total-flex d-flex justify-content-between mt-4 align-items-center">
                                       <h4>Pooled CAO</h4>
                                       <div class ="total-inner flex d-flex gap-3 align-items-center">
                                          <h4>0.0000002307</h4>
                                          <div className="accordin-img-1">
                                            <img src={campassIcon1} alt="" />
                                          </div>    
                                        </div>
                                      </div>  
                                      <div className="total-flex d-flex justify-content-between mt-4 align-items-center">
                                        <h4>Pooled AMPL</h4>
                                       <div class ="total-inner flex d-flex gap-3 align-items-center">
                                          <h4>0.00022648</h4>
                                          <div className="accordin-img-1">
                                            <img src={tIcon1} alt="" />
                                          </div>    
                                        </div>
                                      </div>
                                      <div className="total-flex d-flex justify-content-between mt-4 align-items-center">
                                        <h3 className="green">Your Pool Share</h3>
                                        <h3 className="green">&lt;0.0</h3>
                                      </div>
                                      <div className="total-flex mt-md-5">
                                          <div className="row">
                                             <div className="pool-a-head col-md-5 d-flex align-self-center">
                                               <a href="" className="pool-a-tag green">View Accrued Fees and Analytics</a>
                                             </div>
                                             <div className="total-buttons col-md-7 d-flex gap-3 justify-content-end">
                                               <Button className="pool-btn3" onClick="">Remove</Button>
                                               <Button className="pool-btn4" onClick="">Add</Button>
                                             </div> 
                                            </div>     
                                      </div>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </div>
                
        <div className="link-area d-flex gap-4 mt-5">
          <div className="link-para text-white">
            <p>Don't see a pool you joined?</p>
          </div>
          <div className="pool-link">
            <a href="">Import it.</a>
          </div>
        </div>
      </Container>
     </section>
    </div> 
  );
}

export default Pools;
